import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import VueScrollTo from 'vue-scrollto';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You need this import for the styles

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'


library.add(faBars) //close icon
library.add(faTimes) //close icon

const app = createApp(App);

app.component('font-awesome-icon', FontAwesomeIcon); // Modified here

app.use(router);
app.use(VueScrollTo);

// app is mounted
app.mount('#app');

// init AOS after the main app is mounted
AOS.init({
  startEvent: 'DOMContentLoaded', // default is 'DOMContentLoaded', you can set any event to start AOS animations
  initClassName: 'aos-init', // initial state className
  animatedClassName: 'aos-animate', // animated state className

  offset: 100,
  duration: 500,
  easing: "ease-in-sine",
  delay: 100
});